import type CartPaymentInfo from "~/domains/payment/cart/CartPaymentInfo";
import type CartServiceInfo from "~/domains/payment/cart/CartServiceInfo";
import type DiscountInfo from "../../DiscountInfo";
import type { DiscountInfoType } from "../../DiscountInfoType";
import type ServiceDiscountStrategy from "./ServiceDiscountStrategy";
import { getNdcDiscountDescription, roundPrice } from "~/utils/payment";

export default class NdcFreeVisitServiceDiscountStrategy implements ServiceDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "ndcFreeVisit";
  }

  getDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcFreeVisit",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Free Visit only applies if:
      - Has the service in their cart.
      - Has the minimum number of rounds remaining in the season (default 1).
      - This service is a seasonal service.
    */
    const ndcInfo = cartPaymentInfo.ndc;

    if (
      ndcInfo?.pricingRule === "FreeVisit"
      && ndcInfo?.product?.id === cartServiceInfo.ServiceDefId
      && !cartServiceInfo.isMonthly
      && !cartServiceInfo.isInitialPayment
    ) {
      let minimumRequiredRoundsRemaining = 1;
      let freeRounds = 1;

      const extractXforY = ndcInfo.description.match(/(\d)\s+for\s+(\d)/i);
      if (extractXforY) {
        minimumRequiredRoundsRemaining = Number.parseInt(extractXforY[1]);
        freeRounds = Math.max(Number.parseInt(extractXforY[1]) - Number.parseInt(extractXforY[2]), 0);
      }

      if (cartServiceInfo.remainingRounds >= minimumRequiredRoundsRemaining) {
        const discountValue = roundPrice((cartServiceInfo.mainPrice ?? 0) * freeRounds, "nearest", 2);

        discountInfo.description = `${getNdcDiscountDescription(ndcInfo)} - ${cartServiceInfo.ServiceName}`;
        discountInfo.value = discountValue;
        discountInfo.amount = discountValue;
        discountInfo.serviceDefId = cartServiceInfo.ServiceDefId;
        discountInfo.freeRounds = freeRounds;
      }
    }

    return discountInfo;
  }

  getMonthlyDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcFreeVisit",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }

  getInitialPaymentDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcFreeVisit",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }
}